import React, { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import { PrivateRoutes } from 'routes/rutas'
import { useDispatch } from 'react-redux'
import { addTeacher } from '../../../redux/states/docente'
import { BsKeyFill } from 'react-icons/bs'

const RowTableDocentes = ({ teacher, enableTeacher, schedulesCount = 0, handleAction }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const handleShowSubject = async () => {
        setLoading(true)
        await enableTeacher(teacher.ci)
        dispatch(addTeacher(teacher))
        setLoading(false)
        navigate(`${PrivateRoutes.HABILITARMATERIA}/${teacher.id}`)
    }
    let { nombre, ci, correo } = teacher

    return (
        <tr key={ci} style={{ verticalAlign: 'middle' }}>
            <td>{nombre}</td>
            <td>{correo}</td>
            <td>{ci}</td>
            <td className='text-center'>
                <progress value={schedulesCount * 100} max='100' className='py-0'></progress>
            </td>
            <td className='text-center' style={{ width: '16rem' }}>
                <Button
                    onClick={() => handleShowSubject()}
                    variant='blue'
                    className='text-nowrap me-2 py-1'
                    style={{ minWidth: '7.25rem' }}
                    disabled={loading}
                >
                    {loading && <Spinner className='d-inline-block me-2' size='sm' />}
                    Habilitar
                </Button>
                <Button
                    variant='success'
                    className='me-2 py-1'
                    onClick={() => handleAction('viewSubjects', teacher)}
                    disabled={loading}
                >
                    Más
                </Button>
                <Button
                    className='py-1'
                    onClick={() => handleAction('restorePassword', teacher)}
                    disabled={loading}
                >
                    <BsKeyFill fontSize='1.375rem' />
                </Button>
            </td>
        </tr>
    )
}

export default RowTableDocentes
